import { Injectable } from '@angular/core';
import { Http, URLSearchParams, RequestOptions, Headers, ResponseContentType } from '@angular/http';
import '../../node_modules/rxjs/add/operator/map';
import '../../node_modules/rxjs/add/operator/timeout';
import { UtilService } from '../services/util.service';
import { Observable } from 'rxjs';

@Injectable()
export class FileService{
    params: URLSearchParams = new URLSearchParams();
    url: string;
    protocol: string;

    constructor(private http: Http, private util: UtilService){
        if (location.protocol == 'file:') this.protocol = 'https:';
        else this.protocol = location.protocol;
    }

    fileOperation(action: string, data: FormData, fileName: string){
        let headers = new Headers();
        let options = new RequestOptions({ headers: headers });

        switch(action) {
            case "upload":
                this.url = this.protocol + this.util.getWebServiceURL() + 'file/FileOperation/' + action + '/' + fileName;
                // this.url = this.protocol + '//portal.dksh.com/epclientws_tt/api/file/FileOperation/' + action + '/' + fileName;
                break;
            case "delete":
                this.url = this.protocol + this.util.getWebServiceURL() + 'file/FileOperation/' + action + '/' + fileName;
                // this.url = this.protocol + '//portal.dksh.com/epclientws_tt/api/file/FileOperation/' + action + '/' + fileName;
                break;
        }
        return this.http.post(this.url, data, options).map(e => e.json());
    }

    uploadAttachment(strPrincipalCode: string, strTxnNo: string, data: FormData){
        let headers = new Headers();
        let options = new RequestOptions({headers: headers});

        this.url = this.protocol + this.util.getWebServiceURL() + 'file/UploadAttachment/' + strPrincipalCode + "/" + strTxnNo;
        return this.http.post(this.url, data, options).map(e => e.json());
    }

    retrieveAttachmentList(strPrincipalCode: string, strTxnNo: string){
        let headers = new Headers();
        let options = new RequestOptions({ headers: headers });

        this.url = this.protocol + this.util.getWebServiceURL() + 'file/GetAttachmentList/' + strPrincipalCode + "/" + strTxnNo;
        return this.http.get(this.url, options).map(e => e.json());
    }

    retrieveNumberOfAttachment(strPrincipalCode: string, strTxnNo: string){
        let headers = new Headers();
        let options = new RequestOptions({ headers: headers });

        this.url = this.protocol + this.util.getWebServiceURL() + 'file/GetNumberOfAttachment/' + strPrincipalCode + "/" + strTxnNo;
        return this.http.get(this.url, options).map(e => e.json());
    }

    deleteAttachment(strPrincipalCode: string, strTxnNo: string, strFileName: string){
        let headers = new Headers();
        let options = new RequestOptions({ headers: headers });

        this.url = this.protocol + this.util.getWebServiceURL() + 'file/DeleteAttachment/' + strPrincipalCode + "/" + strTxnNo + '/' + encodeURIComponent(strFileName);
        return this.http.get(this.url, options).map(e => e.json());
    }

    downloadAttachment(strPrincipalCode: string, strTxnNo: string, strFileName: string): Observable<any> {
        let headers = new Headers();
        //let options = new RequestOptions({ headers: headers });
        this.url = this.protocol + this.util.getWebServiceURL() + 'file/DownloadAttachment/' + strPrincipalCode + "/" + strTxnNo + '/' + strFileName;
        
        return this.http.get(this.url, { headers: headers, responseType: ResponseContentType.Blob })
          .map((res) => { return res;}
          );
    }
}



// WEBPACK FOOTER //
// ./src/services/file.service.ts